import React, { useContext, useEffect, useRef, useState } from 'react'
import Slider from "react-slick";
import { getImages } from '../Common/const'
import { Link } from 'react-router-dom';
import SeoMeta from '../Common/SeoMeta';
import { VehicleContext } from '../Context/VehicleContext';

const reviewsList = [
  {
    name: "Darren Magot",
    date: '2 months ago',
    content:
      "I had a great experience with these guys. They have such a wide variety of unique vehicles. Definitely will be going back whenever I’m in the area to see what’s new.",
  },
  {
    name: "R PHOTOSTUDIOS",
    date: 'a month ago',
    content:
      "Jackson was very welcoming when we visited the showroom. Knowledgeable and patient with my son who was so excited to see their cars.",
  },
  {
    name: "cat lover",
    date: '2 months ago',
    content:
      "Tim had great communication. I didn’t see the car in person, so I had to trust…and I ended up very pleased. As described. Thank you",
  },

  {
    name: "Alek Arciniega",
    date: 'a month ago',
    content:
      "Awesome place to go look at exotic cars. The guys working there were very helpful and informative. Definitely recommend coming here and checking this place out.",
  },
  {
    name: "Muntasir Hoque",
    date: '6 days ago',
    content:
      "Excellent experience with purchase and delivery of a vehicle from EEC! Jaxon was my point of contact, and he was incredibly knowledgeable and friendly the entire process. They delivered the vehicle to a location of my choosing, and made the entire experience a pleasure. I cannot recommend Jaxon and EEC enough. This is the best place in California to purchase exotic automobiles!",
  },

  {
    name: "Ishnmuich Perez",
    date: 'a month ago',
    content:
      "Very friendly professional staff. Not only were they very friendly and courteous with my son, but they gave us good information on their weekly car shows held at the parking lot.",
  },
  {
    name: "Summer Shaffer",
    date: '2 months ago',
    content:
      "Whole staff was super friendly and very knowledgeable. Was the easiest car purchase I’ve ever made. Will be my first call when I’m ready for something new!",
  },
];

const Finance = () => {

  const { getCMSData } = useContext(VehicleContext);
  const [cmsData, setCMSData] = useState({});

  const getPageData = async () => {
    setCMSData(await getCMSData('finance'));
  }

  useEffect(() => {
    getPageData();
  }, []);

  const getCMSValue = (field) => {
    return field in cmsData ? cmsData[field] : "";
  }

  const networkImages = [
    'network1.png',
    'network2.png',
    'network3.png',
    'network4.png',
    'network5.png',
    'network6.png',
    'network7.png',
    'network8.png'
  ];
  const sliderRef = useRef(null);
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 2,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: true,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  return (
    <>
      <SeoMeta
        title="Online Credit Application For Exotic Car Financing | EEC"
        description="Apply online for exotic car financing or leasing with EEC. Secure credit app for Tampa, FL and San Clemente, CA, backed by a network of specialty lenders."
        keywords=""
        ogTitle="Online Credit Application For Exotic Car Financing | EEC"
        ogDescription="Apply online for exotic car financing or leasing with EEC. Secure credit app for Tampa, FL and San Clemente, CA, backed by a network of specialty lenders."
      />
      <section className="common-banner-wrap finance-banner-wrap">
        <img src={getImages('finance_hero.webp')} alt='hero' />
        <div className="container">
          <div className='common-banner-pos pt-140 text-center'>
            <h1 className='banner-lg-title text-uppercase wow reveal fadeInUp'>{getCMSValue('financeMainHeading')}</h1>
            <h2 className='md-title mt-3 avenir-next font-2em fw-500 wow reveal fadeInUp'>{getCMSValue('financeSubHeading')}</h2>
            <div className='text-center'>
              <div className='mt-4 pt-2 d-lg-inline-flex align-items-center wow reveal fadeInUp'>
                <div className='me-md-5 pe-md-3'>
                  <Link to='/finance-san-clemente' className='fin-location-btn'><img src={getImages('ca.svg')} /> San Clemente, CA</Link>
                </div>
                <div>
                  <Link to='/finance-tampa' className='fin-location-btn'><img src={getImages('fl.svg')} /> Tampa, FL</Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className='finance-wrap'>
        <div className='container'>
          <div className='network-block'>
            {/* <div className='md-title font-2em eurostile fw-400 text-uppercase wow reveal fadeInUp'>
              UTILIZE OUR NETWORK OF BANKS THAT SPECIALIZE IN <span className='text-orange'>EXOTIC CAR LENDING</span> TO ENSURE YOU ARE GETTING THE <span className='text-orange'>VERY BEST</span> FINANCE OR LEASE STRUCTURE AVAILABLE
            </div> */}
            <div className='md-title font-2em eurostile fw-400 text-uppercase wow reveal fadeInUp'>
              <div
                  dangerouslySetInnerHTML={{
                      __html: getCMSValue('financeContentMainHeading'),
                  }}
              />
            </div>
            <div className='row network-list d-none'>
              {networkImages.map((image, index) => (
                <div className="col-md-3 wow reveal fadeInUp" key={index}>
                  <div className="network-box d-flex align-items-center justify-content-center">
                    <div className="w-100 text-center">
                      <img src={getImages(image)} alt={`Network ${index + 1}`} />
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div className='simple-process-block'>
            <div className='md-title font-2-5em eurostile mb-5 fw-700 text-uppercase text-center wow reveal fadeInUp'>{getCMSValue('financeContentSubHeading')}</div>
            <div className='row gx-xl-5 gx-4'>
              <div className='col-lg-4 wow reveal fadeInUp'>
                <div className='process-box'>
                  <div className='process-circle'>1</div>
                  <div className='xs-title font-1-5em fw-900 text-center text-uppercase mt-4 pt-2 mb-3'>{getCMSValue('financeCard1Title')}</div>
                  <p>{getCMSValue('financeCard1Text')}</p>
                </div>
              </div>
              <div className='col-lg-4 wow reveal fadeInUp'>
                <div className='process-box'>
                  <div className='process-circle'>2</div>
                  <div className='xs-title font-1-5em fw-900 text-center text-uppercase mt-4 pt-2 mb-3'>{getCMSValue('financeCard2Title')}</div>
                  <p>{getCMSValue('financeCard2Text')}</p>
                </div>
              </div>
              <div className='col-lg-4 wow reveal fadeInUp'>
                <div className='process-box'>
                  <div className='process-circle'>3</div>
                  <div className='xs-title font-1-5em fw-900 text-center text-uppercase mt-4 pt-2 mb-3'>{getCMSValue('financeCard3Title')}</div>
                  <p>{getCMSValue('financeCard3Text')}</p>
                </div>
              </div>
            </div>
          </div>
          <div className='finance-application-box'>
            <div className='md-title font-2-5em eurostile fw-900 text-uppercase text-center mb-4 wow reveal fadeInUp'>{getCMSValue('financeOnlineApplicationTitle')}</div>
            <div className='text-center'>
              <div className='d-lg-inline-flex wow reveal fadeInUp'>
                <div className='me-lg-5'>
                  <Link to='/finance-tampa' className='orange-white-btn lg-btn w-240 d-inline-block font-1-2em fw-700 text-uppercase'>Tampa</Link>
                </div>
                <div>
                  <Link to='/finance-san-clemente' className='orange-white-btn lg-btn w-240 d-inline-block font-1-2em fw-700 text-uppercase'>San Clemente</Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {getCMSValue('financeShowGoogleReviews') && (
        <section className='finance-review-wrap'>
          <div className='finance-review-block'>
            <div className='container'>
              <div className='text-center mb-md-5 mb-3'>
                <h3 className='xs-title text-uppercase text-orange mb-2 reveal wow fadeInUp'>Recent</h3>
                <h3 className='xxl-title font-2-5em fw-700 text-uppercase reveal wow fadeInUp'>Google Reviews</h3>
              </div>
              <div className='reveal wow fadeIn'>
                <Slider ref={sliderRef} {...settings} className='review-slider'>
                  {reviewsList.map((review, index) => (
                    <div className="review-item" key={index}>
                      <div className="review-box">
                        <div className="d-flex justify-content-between mt-1">
                          <div>
                            <div className="reviewer-name">{review.name}</div>
                            <div className="d-flex align-items-center">
                              {[...Array(5)].map((_, i) => (
                                <img key={i} className="me-1 rs-icon" src={getImages("star.svg")} alt="star" />
                              ))}
                            </div>
                          </div>
                          <div>
                            <div className="quote-icon mb-2">
                              <img src={getImages("quote-shape.png")} alt="quote" />
                            </div>
                          </div>
                        </div>
                        <div className="review-mnh">
                          <p className="clamp-4">
                            {review.content}
                          </p>
                        </div>
                      </div>
                    </div>
                  ))}

                </Slider>
              </div>
            </div>
          </div>
        </section>
      )}
    </>
  )
}

export default Finance